import { popStack, pushStack, state } from './common'

let init = false

export default {
  use: (Vue, Router, loadLanguageAsync) => {
    Vue.use(Router);
    const { routerPreFix } = require('$proDirname/prefix');
    //  设置 spa 的路由前缀
    const prefix = window?.ssrConfig?.routerConfig?.name ?? `/${routerPreFix.foundPage}/index`;

    const router = new Router({
      mode: 'history',
      prefix,
      routes: [
        {
          path: `*`,
          redirect: `${prefix}/detail`
        },
        {
          name: 'detail',
          path: `${prefix}/detail`,
          component: resolve => import('./detail').then(resolve)
        },
        {
          name: 'report',
          path: `${prefix}/report`,
          component: resolve => import('./report').then(resolve)
        },
        {
          name: 'detail-redirect',
          path: `${prefix}/detailRedirect`,
          component: resolve => import('./detail-redirect').then(resolve)
        }
      ]
    });
    //  路由切换懒加载对应的国家化文案
    router.beforeEach((to, from, next) => {
      const fromName = from.name
      const toName = to.name
      if (toName === 'detail' || toName === 'detail-redirect') {
        const isPush = !!to.params.isPush
        const id = to.query.id
        if ((!isPush && fromName !== 'report') && init) {
          console.log('pop stack')
          popStack()
        }
        if (!init) {
          init = true
          pushStack({
            id,
            scrollHeight: 0
          })
        }
      }
      if (window.$vm?.$Statistics) {
        window.$vm?.$Statistics.onEvent('page', from.name, {
          url: window.location.href
        });
      }
      console.log(JSON.parse(JSON.stringify(state.routesStack)))
      loadLanguageAsync({
        router: to.name
      })
        .then(() => next())
        .catch(() => next());
    });
    return router;
  }
};
